<template>
    <div style="height: 100vh;">
        <div style="">
            <a-card title="" style="border-radius: 20px;" :bordered="false">
                <div class="actions">

                    <p style="margin-left: 10px; margin-top: 3px; font-size: 15px; color: #05004E">Add New Contact</p>

                    <div style="display:flex; justify-content: space-around;">
                        <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                        Replenish Low Stock
                        <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                        </a-button> -->


                        <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->


                        <router-link to="/pipeline/contacts">
                            <a-button style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;">
                                Cancel
                            </a-button>
                        </router-link>

                        <a-button :loading="loading" @click="handleAddContact"
                            style="border-raduis:6px; background: #26A246;color:#fff">
                            Save
                        </a-button>

                    </div>
                </div>

                <div style="margin-bottom: 30px; padding: 90px">
                    <div>
                        <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: #9197B3;">
                                Contact Image
                            </p>
                            <div class="clearfix mt-4">
                                <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    list-type="picture-card" :file-list="fileList" :beforeUpload="beforeUpload"
                                    @preview="handlePreview" @change="handleChange" class="upload">
                                    <div>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">
                                            Upload
                                        </div>
                                    </div>
                                </a-upload>
                                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                    <img alt="example" style="width: 100%" :src="previewImage" />
                                    <h4 style="display:flex;justify-content: center;margin-top:15px">Image Name: <span
                                            style="margin-left:10px">{{ fileSelected.name }}</span></h4>
                                    <div style="display:flex;justify-content: center;">
                                    </div>
                                </a-modal>
                            </div>
                        </div>
                        <div>
                            <div>
                                <a-form-model ref="addContactRef" :model="addContactModel" :rules="rules">
                                    <p
                                        style="display:flex;justify-content: start;margin-top: 60px;font-size:15px; color: #9197B3;">
                                        Contact Information
                                    </p>
                                    <a-row>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="title" label="Title" prop="title">
                                                <a-select v-model="addContactModel.title" placeholder="">
                                                    <a-select-option value="0">
                                                        Mr.
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Mrs.
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Miss.
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Dr.
                                                    </a-select-option>
                                                    <a-select-option value="4">
                                                        Prof.
                                                    </a-select-option>
                                                    <a-select-option value="5">
                                                        Rev.
                                                    </a-select-option>
                                                    <a-select-option value="6">
                                                        Hon.
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="firstName" label="First Name" prop="firstName">
                                                <a-input v-model="addContactModel.firstName" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="lastName" label="Last Name" prop="lastName">
                                                <a-input v-model="addContactModel.lastName" />
                                            </a-form-model-item>

                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="email" label="Email" prop="email">
                                                <a-input v-model="addContactModel.email" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="phoneNumber" label="Phone" prop="phoneNumber">
                                                <a-input v-model="addContactModel.phoneNumber" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="otherPhoneNumber" label="Other Phone" prop="otherPhoneNumber">
                                                <a-input v-model="addContactModel.otherPhoneNumber" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="dateOfBirth" label="Date of Birth" prop="dateOfBirth">
                                                <a-date-picker :format="dateFormat"
                                                    v-model="addContactModel.dateOfBirth" show-time type="date"
                                                    placeholder="Pick a date" style="width: 100%;" />
                                            </a-form-model-item>
                                            <a-form-model-item ref="isPrimary" :label-col="{ span: 10 }"
                                                :wrapper-col="{ span: 8 }" label="Set as Primary Contact"
                                                prop="isPrimary">
                                                <a-switch v-model="addContactModel.isPrimary" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 8 }"
                                                ref="emailOpt" label="Email Opt" prop="emailOpt">
                                                <a-switch v-model="addContactModel.emailOpt" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 8 }"
                                                ref="smsOpt" label="SMS Opt" prop="smsOpt">
                                                <a-switch v-model="addContactModel.smsOpt" />
                                            </a-form-model-item>



                                            <!-- <a-form-model-item ref="name" label="Email Opt Out" prop="name">
                                                <a-switch />
                                            </a-form-model-item> -->
                                        </a-col>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="accountName" label="Account Name" prop="accountName">
                                                <a-input v-model="addContactModel.accountName" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="accountType" label="Segment Type" prop="accountType">
                                                <a-select v-model="addContactModel.accountType" placeholder="">
                                                    <a-select-option value="0">
                                                        Agrovet
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        AHP
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Cooperative
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Hatchery
                                                    </a-select-option>
                                                    <a-select-option value="4">
                                                        Staff
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="position" label="Position" prop="position">
                                                <a-input v-model="addContactModel.position" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="department" label="Department" prop="department">
                                                <a-input v-model="addContactModel.department" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="userId" label="Contact Owner" prop="userId">
                                                <a-select v-model="addContactModel.userId" placeholder="">
                                                    <a-select-option v-for="owner in clients.data" :key="owner.id">
                                                        {{ owner.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="source" label="Contact Source" prop="source">
                                                <a-select v-model="addContactModel.source" placeholder="">
                                                    <a-select-option value="0">
                                                        Outreach Events
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Referrals
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Inbund Marketing
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Cold Calling
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                    <p
                                        style="display:flex;justify-content: start;margin-top: 90px;font-size:15px; color: #9197B3;">
                                        Address Information
                                    </p>
                                    <a-row>
                                        <a-col :span="8">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="country" label="Country" prop="country">
                                                <a-select v-model="addContactModel.country" placeholder="">
                                                    <a-select-option value="0">
                                                        Ghana
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Kenya
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="region" label="Region" prop="region">
                                                <a-select @change="handleRegionChange" v-model="addContactModel.region"
                                                    placeholder="">
                                                    <a-select-option v-for="region in regions" :key="region.id">
                                                        {{ region.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="subRegion" label="Sub Region" prop="subRegion">
                                                <a-select @change="handleSubRegionChange"
                                                    v-model="addContactModel.subRegion" placeholder="">
                                                    <a-select-option v-for="subRegion in subRegions"
                                                        :key="subRegion.id">
                                                        {{ subRegion.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="communityId" label="Town" prop="communityId">
                                                <a-select @change="''" v-model="addContactModel.communityId"
                                                    placeholder="">
                                                    <a-select-option v-for="town in towns" :key="town.id">
                                                        {{ town.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                    <p
                                        style="display:flex;justify-content: start;margin-top: 90px;font-size:15px; color: #9197B3;">
                                        Description Information
                                    </p>
                                    <a-form-model-item :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }"
                                        ref="description" label="Description" prop="description">
                                        <a-textarea v-model="addContactModel.description"
                                            placeholder="Enter description...."
                                            :auto-size="{ minRows: 2, maxRows: 2 }" />
                                    </a-form-model-item>
                                </a-form-model>
                            </div>
                        </div>
                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default {
    name: 'AddContact',
    components: {

    },
    data() {
        return {
            current: 0,
            activeKey: ['0'],
            showProductCategoryTab: false,
            showProductTab: true,
            showProductImageTab: true,
            showInventoryTab: true,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            imgSelected: false,
            fileSelected: {},
            selectedValue: "",
            newFilelist: [],
            labelCol: { span: 8 },
            wrapperCol: { span: 15 },
            sources: [],
            loading: false,
            dateFormat: 'DD-MM-YYYY',
            addContactModel: {
                userId: '',
                communityId: "",
                firstName: "",
                lastName: "",
                accountName: "",
                accountType:"",
                source:"",
                address: "",
                title: "",
                phoneNumber:"",
                otherPhoneNumber:"",
                email: "",
                region: "",
                country:"",
                position: "",
                department: "",
                description:"",
                dateOfBirth: "",
                isPrimary: null,
                emailOpt: null,
                smsOpt: null,
            },
            regions: [],
            subRegions: [],
            towns: [],
            rules: {
                firstName: [
                    { required: true, message: 'Please enter first name', trigger: 'change' },
                ],
                lastName: [
                    { required: true, message: 'Please enter last name', trigger: 'change' },
                ],
                userId: [
                    { required: true, message: 'Please select contact owner', trigger: 'change' },
                ],
                communityId: [
                    { required: true, message: 'Please select community', trigger: 'change' },
                ],
                accountName: [
                    { required: true, message: 'Please enter account name', trigger: 'change' },
                ],
                accountType: [
                    { required: true, message: 'Please select account type', trigger: 'change' },
                ],
                source: [
                    { required: true, message: 'Please select source', trigger: 'change' },
                ],
               
                phoneNumber: [
                    { required: true, message: 'Please enter phone number', trigger: 'change' },
                ],
               
                email: [
                    { required: true, message: 'Please enter email', trigger: 'change' },
                ],
                country: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
                region: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
                subRegion: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
               
            }
        };
    },
    computed: {
        ...mapGetters(['getStepCount']),
        clients() {
            return this.$store.getters["generic/GetUsers"];
        },
    },
    methods: {
        ...mapActions(['setStepCount', 'setProductGroupInfo', 'getAllCommunitiesById', 'getAllSubRegionById','getAllRegion', 'setProductDetailsInfo']),
        // onChange(current) {
        //     // console.log('onChange:', current);
        //     this.current = current;
        //     if(current === 0){
        //         this.setStepCount(0)
        //         this.$router.push(`/new-product`).catch(()=>{});
        //     }else if(current === 1){
        //         this.setStepCount(1)
        //         this.$router.push(`/product-details`).catch(()=>{});
        //     }
        //     else if(current === 2){
        //         this.setStepCount(2)
        //         this.$router.push(`/product-image`).catch(()=>{});
        //     }else if(current === 3){
        //         this.setStepCount(3)
        //         this.$router.push(`/inventory-details`).catch(()=>{});
        //     }
        // },

        redirectUrl() {
            this.$router.push(`/customers`).catch(() => { });
        },

        async handleRegionChange(id) {
            const response = await this.getAllSubRegionById(id);
            this.subRegions = response.data.data;
        },

        async handleSubRegionChange(id) {
            const response = await this.getAllCommunitiesById(id);
            this.towns = response.data.data;
        },

        handleAddContact() {
            this.$refs.addContactRef.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    
                    const request = {
                        userId: this.addContactModel?.userId,
                        title: this.addContactModel?.title,
                        communityId: this.addContactModel?.communityId,
                        firstName: this.addContactModel?.firstName,
                        lastName: this.addContactModel?.lastName,
                        accountName: this.addContactModel?.accountName,
                        accountType: parseInt(this.addContactModel?.accountType),
                        source: parseInt(this.addContactModel?.source),
                        address: this.addContactModel?.address,
                        phoneNumber: this.addContactModel?.phoneNumber,
                        otherPhoneNumber: this.addContactModel?.otherPhoneNumber,
                        email: this.addContactModel?.email,
                        position: this.addContactModel?.position,
                        department: this.addContactModel?.department,
                        description: this.addContactModel?.description,
                        dateOfBirth: this.addContactModel?.dateOfBirth ? this.addContactModel?.dateOfBirth?.toISOString() : null,
                        isPrimary: this.addContactModel.isPrimary ? true : false,
                        emailOpt: this.addContactModel.emailOpt ? true : false,
                        smsOpt: this.addContactModel.smsOpt ? true : false
                    }

                    const response = await this.$store.dispatch("pipeline/addContact", request);

                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("New Contact Created Successfully")
                        this.$refs.addContactRef.resetFields();
                        this.$router.push(`/pipeline/contacts`).catch(() => { });
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
      
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.fileSelected = file
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        async loadRegions() {
            const response = await this.getAllRegion();
            this.regions = response.data.data
        },

    },
    created() {
        this.$watch(
            () => this.$store.getters.getStepCount,
            (newValue) => {
                if (newValue) {
                    this.current = this.getStepCount
                    if (this.current === 0) {
                        this.setStepCount(0)
                        this.activeKey = ['0'];
                        this.showProductCategoryTab = false
                        this.showProductTab = true
                        this.showProductImageTab = true
                        this.showInventoryTab = true
                    } else if (this.current === 1) {
                        this.setStepCount(1)
                        this.activeKey = ['1'];
                        this.showProductCategoryTab = true
                        this.showProductTab = false
                        this.showProductImageTab = true
                        this.showInventoryTab = true
                    }
                    else if (this.current === 2) {
                        this.setStepCount(2)
                        this.activeKey = ['2'];
                        this.showProductCategoryTab = true
                        this.showProductTab = true
                        this.showProductImageTab = false
                        this.showInventoryTab = true
                    } else if (this.current === 3) {
                        this.setStepCount(3)
                        this.activeKey = ['3'];
                        this.showProductCategoryTab = true
                        this.showProductTab = true
                        this.showProductImageTab = true
                        this.showInventoryTab = false
                    }
                }
            }
        );
        this.loadRegions();
        this.$store.dispatch("generic/FetchUsers", { perPage: -1 });
    },
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.img_size {
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.descInputText {
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}

.dropdownItem {
    width: 336px;
    border-radius: 5px;
}

.selecInput {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}

.ant-layout-sider {
    background: #FFFFFF;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    background: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    border-color: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon:hover {
    color: #418a49;
}

.slider>>>.anticon {
    vertical-align: 2px;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #418a49;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon {
    color: #418a49;
}

.slider>>>.ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
    background-color: #418a49;
}

.slider {
    flex: none !important;
    max-width: none !important;
    min-width: none !important;
    width: 250px !important;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.upload-list-inline>>>.ant-upload-list-item {
    float: left;
    width: 200px;
    margin-right: 8px;
}

.upload-list-inline>>>.ant-upload-animate-enter {
    animation-name: uploadAnimateInlineIn;
}

.upload-list-inline>>>.ant-upload-animate-leave {
    animation-name: uploadAnimateInlineOut;
}

.ant-collapse-borderless {
    background-color: #fff;
    border: 0;
}
</style>

